import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { toEntry } from 'services/cms/typesUtil';
import React, { FC, HTMLAttributes, useRef } from 'react';
import styles from './DeviceItemContent.module.scss';
import { TextV2 } from 'components/TextV2/TextV2';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { usePan } from 'hooks/usePan';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

export interface IDeviceItemProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<Subject>;
  onPanNext?: () => void;
  onPanPrev?: () => void;
}

export const DeviceItemContent: FC<IDeviceItemProps> = ({
  entry,
  className,
  children,
  onPanPrev,
  onPanNext,
  ...props
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const { pointerRef, ...pointerEvents } = usePan({
    cssVarEl: rootRef,
    isFirstIndex: false,
    isLastIndex: false,
    onPanNext,
    onPanPrev,
  });

  if (!entry) return null;

  const { subTitle, blurb, link, richBlurb } = entry;

  return (
    <div className={styles.deviceItemContent} {...props} {...pointerEvents}>
      <TextV2 className={styles.deviceItemContentTitle} variant="modern-h4" value={subTitle} tagName="h4" />

      <TextV2 className={styles.deviceItemContentBody} variant="modern-body" value={blurb} tagName="p" />
      <RichBlurb className={styles.deviceItemContentBody} document={richBlurb} />

      {link && (
        <ContentLinkV2 entry={toEntry(link)} className={styles.deviceItemContentLink} hideTitle>
          <TextWithArrow>{link.title}</TextWithArrow>
        </ContentLinkV2>
      )}

      {children}
    </div>
  );
};
